import moment from 'moment';

/**
 * ACTION DATA SOURCE ADD INIT
 * Reset add data source
 */
export const dataSourceAddInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_SOURCE_ADD_INIT' });
  };
};

/**
 * ACTION ADD DATA SOURCE
 * Add data source
 * @param {object} data - data source data
 */
export const dataSourceAdd = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (
      profileCompany !== undefined &&
      data !== undefined &&
      data.name !== undefined
    ) {
      dispatch({ type: 'DATA_SOURCE_ADD_PENDING' });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const dataSourceAddTags = (dataSourceId, subcollection, type) => {
        if (dataSourceId && subcollection && subcollection.length > 0)
          subcollection.forEach(([id, { name, tags }]) => {
            if (id && name && tags && Object.values(tags).length > 0) {
              batch.set(
                firestore
                  .collection('companies')
                  .doc(profileCompany.id)
                  .collection('data_sources')
                  .doc(dataSourceId)
                  .collection(type)
                  .doc(id),
                {
                  name,
                  tags,
                }
              );
            }
          });
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('data_sources')
        .add({
          name: data.name,
          createdAt: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
          updatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
        })
        .then(async (dataSource) => {
          if (
            data.photo_categories &&
            Object.keys(data.photo_categories).length > 0
          )
            dataSourceAddTags(
              dataSource.id,
              Object.entries(data.photo_categories),
              'photo_categories'
            );

          if (
            data.objects_categories &&
            Object.keys(data.objects_categories).length > 0
          )
            dataSourceAddTags(
              dataSource.id,
              Object.entries(data.objects_categories),
              'objects_categories'
            );

          return await batch
            .commit()
            .then(() => {
              dispatch({ type: 'DATA_SOURCE_ADD_SUCCESS' });
              return true;
            })
            .catch((err) => {
              dispatch({ type: 'DATA_SOURCE_ADD_ERROR', err });
              return false;
            });
        })
        .catch((err) => {
          dispatch({ type: 'DATA_SOURCE_ADD_ERROR', err });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION EDIT DATA SOURCE
 * Edit data source
 * @param {object} data - data source data
 */
export const dataSourceEdit = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (
      profileCompany !== undefined &&
      data !== undefined &&
      data.id !== undefined &&
      data.name !== undefined
    ) {
      dispatch({ type: 'DATA_SOURCE_ADD_PENDING' });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const dataSourceAddTags = (dataSourceId, subcollection, type) => {
        if (dataSourceId && subcollection && subcollection.length > 0)
          subcollection.forEach(([id, { name, tags }]) => {
            if (id && name && tags && Object.values(tags).length > 0) {
              batch.set(
                firestore
                  .collection('companies')
                  .doc(profileCompany.id)
                  .collection('data_sources')
                  .doc(dataSourceId)
                  .collection(type)
                  .doc(id),
                {
                  name,
                  tags,
                }
              );
            }
          });
      };

      const dataSourceDeleteTags = async (dataSourceId, type) => {
        if (dataSourceId && type) {
          return await firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('data_sources')
            .doc(dataSourceId)
            .collection(type)
            .get()
            .then(async (querySnapshot) => {
              querySnapshot.forEach(async (category) => {
                batch.delete(
                  firestore
                    .collection('companies')
                    .doc(profileCompany.id)
                    .collection('data_sources')
                    .doc(dataSourceId)
                    .collection(type)
                    .doc(category.id)
                );
              });

              return true;
            });
        } else return false;
      };
      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('data_sources')
        .doc(data.id)
        .update({
          name: data.name,
          updatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
        })
        .then(async () => {
          await dataSourceDeleteTags(data.id, 'photo_categories');

          if (
            data.photo_categories &&
            Object.keys(data.photo_categories).length > 0
          )
            dataSourceAddTags(
              data.id,
              Object.entries(data.photo_categories),
              'photo_categories'
            );

          await dataSourceDeleteTags(data.id, 'objects_categories');

          if (
            data.objects_categories &&
            Object.keys(data.objects_categories).length > 0
          )
            dataSourceAddTags(
              data.id,
              Object.entries(data.objects_categories),
              'objects_categories'
            );

          return await batch
            .commit()
            .then(() => {
              dispatch({ type: 'DATA_SOURCE_ADD_SUCCESS' });
              return true;
            })
            .catch((err) => {
              dispatch({ type: 'DATA_SOURCE_ADD_ERROR', err });
              return false;
            });
        })
        .catch((err) => {
          dispatch({ type: 'DATA_SOURCE_ADD_ERROR', err });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION DATA SOURCE DELETE INIT
 * Reset add data source
 */
export const dataSourceDeleteInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_SOURCE_DELETE_INIT' });
  };
};

/**
 * ACTION DELETE DATA SOURCE
 * Delete data source
 * @param {object} data - data source data
 */
export const dataSourceDelete = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (
      profileCompany !== undefined &&
      data !== undefined &&
      data.id !== undefined
    ) {
      dispatch({ type: 'DATA_SOURCE_DELETE_PENDING' });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const dataSourceDeleteTags = async (dataSourceId, type) => {
        if (dataSourceId && type) {
          return await firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('data_sources')
            .doc(dataSourceId)
            .collection(type)
            .get()
            .then(async (querySnapshot) => {
              querySnapshot.forEach(async (category) => {
                batch.delete(
                  firestore
                    .collection('companies')
                    .doc(profileCompany.id)
                    .collection('data_sources')
                    .doc(dataSourceId)
                    .collection(type)
                    .doc(category.id)
                );
              });
              return true;
            });
        } else return false;
      };
      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('data_sources')
        .doc(data.id)
        .delete()
        .then(async () => {
          await dataSourceDeleteTags(data.id, 'photo_categories');

          await dataSourceDeleteTags(data.id, 'objects_categories');

          return await batch
            .commit()
            .then(() => {
              dispatch({ type: 'DATA_SOURCE_DELETE_SUCCESS' });
              return true;
            })
            .catch((err) => {
              dispatch({ type: 'DATA_SOURCE_DELETE_ERROR', err });
              return false;
            });
        })
        .catch((err) => {
          dispatch({ type: 'DATA_SOURCE_DELETE_ERROR', err });
          return false;
        });
    } else return false;
  };
};
